import AbstractNode from './AbstractNode';
import {textblockTypeInputRule} from 'prosemirror-inputrules';
import {
  defaultMarkdownParser,
  defaultMarkdownSerializer,
  schema as markdownSchema,
} from 'prosemirror-markdown';
import {setBlockType} from 'prosemirror-commands';

export default class CodeBlock extends AbstractNode {
    get name() {
        return "code_block";
    }

    get schema() {
        return markdownSchema.spec.nodes.get("code_block");
    }

    toMarkdown(state, node) {
        defaultMarkdownSerializer.nodes.code_block(state, node);
    }

    get parseMarkdown() {
        return defaultMarkdownParser.tokens.code_block;
    }

    inputRules({type}) {
        return [textblockTypeInputRule(/^\s*```$/, type)];
    }

    keys({type}) {
        return {
            "Shift-Ctrl-\\": setBlockType(type)
        };
    }

    commands({schema}) {
        return {
            createCodeBlock: () => view => view.dispatch(view.state.tr.replaceSelectionWith(schema.nodes.code_block.create()).scrollIntoView())
        }
    }
}